import { render, staticRenderFns } from "./PanelCompetitionSettingStoperMain.vue?vue&type=template&id=d1dc6ac6&scoped=true&"
import script from "./PanelCompetitionSettingStoperMain.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoperMain.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStoperMain.vue?vue&type=style&index=0&id=d1dc6ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dc6ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1dc6ac6')) {
      api.createRecord('d1dc6ac6', component.options)
    } else {
      api.reload('d1dc6ac6', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingStoperMain.vue?vue&type=template&id=d1dc6ac6&scoped=true&", function () {
      api.rerender('d1dc6ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionSettingStoperMain.vue"
export default component.exports